<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="immagine3"><span>Sandrine Collette</span></p>
<p class="immagine4"><span>NOTHING BUT DUST</span></p>
<p class="immagine2" id="traduzione"><span><i>Translated from the French<br/>
    by Alison Anderson</i></span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?c5704de6